"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
var _organizations = require("@/api/organizations");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _settings = require("@/settings");
var _autoTableHeight = require("@/views/mixins/autoTableHeight");
var _lodash = _interopRequireDefault(require("lodash"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'OrganizationList',
  mixins: [_autoTableHeight.autoTableHeight],
  data() {
    return {
      organizationList: [],
      tableLoading: false /* use for el-table */,
      total: 0,
      query: {
        page: 1,
        limit: _settings.pageSize,
        sort: 'createdAt:desc'
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    hasPermission(value) {
      return (0, _permission.default)(value);
    },
    doSearch(page) {
      this.query.page = page;
      this.getList();
    },
    getList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      (0, _organizations.getAllOrganizations)(token, this.query).then(response => {
        this.organizationList = response.data.rows;
        this.total = response.data.count;
        this.tableLoading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('getAllOrganizations-api-error', error);
        this.tableLoading = false;
        (0, _log.displayPopupMessage)(error, 'error');
        // this.$message({ type: 'error', showClose: true, duration: 5000, message: error.response.data.message })
      });
    },
    assignUsers(row) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      const id = row.id;
      const emailDomains = row.emailDomains;
      const message = `
  <div>
    This will search all existing users who have the following email domain(s), and assign them to this organization. Continue?<br>
    <ol style="padding-left: 20px; margin: 0;list-style-type: decimal;">
      ${emailDomains.map(domain => `<li>${domain}</li>`).join('')}
    </ol>
  </div>
`;
      this.$confirm(message, 'Warning', {
        dangerouslyUseHTMLString: true,
        // 允许渲染 HTML
        type: 'warning'
      }).then(() => {
        const loadingInstance = this.$loading({
          // Show loading indicator
          lock: true,
          text: 'Processing...',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        const formData = {
          organizationId: id
        };
        (0, _organizations.assignUsersToOrganization)(token, formData).then(response => {
          const msg = response.data.message;
          (0, _log.displayPopupMessage)(msg, 'success');
        }).catch(error => {
          (0, _log.showDebugLog)('assignUsersToOrganization-api-error', error);
          (0, _log.displayPopupMessage)(error, 'error');
        }).finally(() => {
          loadingInstance.close(); // Hide loading indicator when done (success or error)
        });
      }).catch(() => {
        const msg = 'canceled';
        (0, _log.displayPopupMessage)(msg, 'info');
      });
    },
    handleSizeChange(val) {
      this.query.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$parent.$emit('onSelectionChange', val);
    },
    sort(data) {
      const {
        prop,
        order
      } = data;
      if (prop === 'name') {
        order === 'ascending' ? this.query.sort = 'name:asc' : this.query.sort = 'name:desc';
      }
      if (prop === 'createdAt') {
        order === 'ascending' ? this.query.sort = 'createdAt:asc' : this.query.sort = 'createdAt:desc';
      }
      this.doSearch(1);
    }
  }
};